import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./ecommerce.css"
import { Link } from 'react-router-dom';

import Ecommimg from "../../../assets/images/Industry Page/e-commerce.jpg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Faq from "./faq-ecommerce";
import Swiper from "../Bfsi Solution/swiper";

import SEO from "../../seo";

export default function Ecommerce() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
    const CounterOnScroll = ({ end, duration = 2, className }) => {
        const { ref, inView } = useInView({
            triggerOnce: true,
            threshold: 0.3,
        });

        return (
            <span ref={ref}>
                {inView ? (
                    <CountUp end={end} duration={duration} className={className} />
                ) : (
                    <span className={className}>0</span>
                )}
            </span>
        );
    };
    return (
        <div className='product-brand'>
                <SEO
                title="E-commerce"
                description="Industries Take Advantage of E-commerce Software Development Create best ecommerce software solutions with the most famous ecommerce software development company. At Horizon WebInfo Pvt Ltd, we are committed to revolutionizing the way businesses operate digitally. We enable businesses of all sizes to be successful in the online business world with our e-commerce systems and logistics [&hellip;]"
                canonical="https://www.hwplindia.com/industries/e-commerce/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/industries-e-commerce-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>E-commerce</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to='/industries'>Industries</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>E-commerce</li>
                    </ul>
                </div>
            </section>
            <section className='bfsi'>
                <section className="ai-ml-main">
                    <div className='ai-ml-container'>
                        {/* Content Section */}
                        <div className="branding-content">
                            {/* CTA */}
                            <section className="cta-section">
                                <span className='tech'>Industries</span>
                                <h3 className='tech-h3'>Take Advantage of E-commerce Software Development</h3>
                                <p className='email'>
                                   Create best ecommerce software solutions with the most famous ecommerce software development company. At Horizon Webinfo Pvt. Ltd. we are committed to revolutionizing the way businesses operate digitally. We enable businesses of all sizes to be successful in the online business world with our e-commerce systems and logistics solutions.
                                </p>
                            </section>
                            <section className="Industri-section">
                                <div className="industri-card">
                                    <h3 className="indu-title">User-Friendly Product Catalog</h3>
                                    <p>
                                        <strong>Details:</strong> Present products in a well-organized catalog with categories, filters, and search functionality.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Enhance user experience, simplify navigation, and improve product discovery.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Responsive Design</h3>
                                    <p>
                                        <strong>Details:</strong> Ensure the website is accessible and functions seamlessly across various devices and screen sizes.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Reach a wider audience, improve user engagement, and enhance mobile shopping experience.


                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Secure Checkout Process</h3>
                                    <p>
                                        <strong>Details:</strong> Implement secure payment gateways, SSL encryption, and user authentication for a safe and trustworthy checkout process.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Boost customer confidence, reduce cart abandonment, and ensure transaction security.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Multiple Payment Options</h3>
                                    <p>
                                        <strong>Details:</strong> Provide a variety of payment methods, including credit cards, digital wallets, and other popular options.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Increase conversion rates, accommodate diverse customer preferences, and expand payment flexibility.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Order Tracking and Notifications</h3>
                                    <p>
                                        <strong>Details:</strong> Enable customers to track their orders in real-time and receive notifications on order status.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Enhance transparency, reduce customer inquiries, and improve post-purchase experience.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Product Reviews and Ratings</h3>
                                    <p>
                                        <strong>Details:</strong> Allow customers to leave reviews and ratings for products, fostering trust and aiding purchase decisions.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Build credibility, assist shoppers in decision-making, and encourage customer engagement.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Personalized User Accounts</h3>
                                    <p>
                                        <strong>Details:</strong> Offer user accounts for personalized experiences, order history, and saved preferences.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> IEncourage customer loyalty, simplify reordering, and provide tailored recommendations.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Dynamic Pricing and Discounts</h3>
                                    <p>
                                        <strong>Details:</strong> Implement dynamic pricing strategies, discount codes, and promotional offers to attract and retain customers.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Drive sales, create a sense of urgency, and incentivize repeat purchases.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Inventory Management</h3>
                                    <p>
                                        <strong>Details:</strong> Track and manage inventory levels in real-time, automate restocking, and prevent overselling.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Optimize stock levels, reduce errors, and ensure product availability.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Customer Support Integration</h3>
                                    <p>
                                        <strong>Details:</strong> Provide accessible customer support through live chat, email, or a dedicated helpdesk.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improve customer satisfaction, address queries promptly, and build a positive reputation.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Social Media Integration</h3>
                                    <p>
                                        <strong>Details:</strong> Enable sharing of products on social media platforms and integrate social login options.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Expand brand visibility, drive traffic, and leverage social proof for marketing.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">SEO-Friendly Architecture</h3>
                                    <p>
                                        <strong>Details:</strong> Optimize the website for search engines with clean URLs, meta tags, and sitemaps.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improve search engine rankings, drive organic traffic, and increase online visibility.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Cross-Selling and Upselling</h3>
                                    <p>
                                        <strong>Details:</strong> Recommend related products and suggest upgrades to increase average order value.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Boost revenue, enhance customer experience, and maximize sales opportunities.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Returns and Refunds Management</h3>
                                    <p>
                                        <strong>Details:</strong> Streamline the process for returns and refunds with clear policies and user-friendly interfaces.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Build trust, simplify customer interactions, and maintain a positive brand image.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                    <section className='bfsi-clor'>
                        <section class="bfsi-section">
                            <div class="bfsi-grid">
                                <div class="bfsi-left">
                                    <h2>
                                        Meet Best E-commerce Software
                                        Development Company
                                    </h2>

                                    <p>
                                        Ready to take your e-commerce and logistics operations to new heights? Partner with us for unparalleled expertise, innovation, and dedicated support. Contact us today to discuss how we can tailor our solutions to drive your business success.
                                    </p>

                                    <div class="bfsi-stats">
                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={20} duration={2} className="counter" /> +
                                            </h3>
                                            <span>Years Of Experience</span>
                                        </div>

                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={5000} duration={3} className="counter" /> +
                                            </h3>
                                            <span>Happy Customers</span>
                                        </div>

                                    </div>
                                    <span className='elementor-divider-separator'></span>
                                </div>

                                <div class="bfsi-right">
                                    <div class="red-shape"></div>
                                    <img src={Ecommimg} class="bfsi-img" />
                                </div>
                            </div>
                        </section>
                    </section>

                    <Faq />
                    <Swiper />

                </section>
            </section>
        </div>
    );
}